import {resourcesSliceFactory} from "../../../../setup/redux/slice/resourcesSlice";

export const ownersSlice = resourcesSliceFactory('owners');
